export function getCurrentPosition() {
  if (!navigator.geolocation) {
    return Promise.reject({ message: '浏览器不支持地理位置功能' });
  }
  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      pos => {
        resolve({
          latitude: pos.coords.latitude,
          longitude: pos.coords.longitude,
        });
      },
      err => {
        reject(err);
      },
    );
  });
}
